import React from "react"
import PropTypes from "prop-types"
import { motion } from "framer-motion"

const AnimatedTagline = ({ text = "Where creative projects come to life" }) => {
  return (
    <div className="auth-tagline" aria-hidden="true">
      <motion.div
        className="auth-tagline__track"
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          duration: 60,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        <span className="auth-tagline__text">{text}</span>
        <span className="auth-tagline__text">{text}</span>
      </motion.div>
    </div>
  )
}

AnimatedTagline.propTypes = {
  text: PropTypes.string,
}

export default AnimatedTagline
